import { render, staticRenderFns } from "./MaterialDonationReopenModal.vue?vue&type=template&id=55268fd8&"
import script from "./MaterialDonationReopenModal.vue?vue&type=script&lang=js&"
export * from "./MaterialDonationReopenModal.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDonationReopenModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports